/**
 * Created by aaron on 9/22/14.
 */
var sw = require('js/lib/sw');
var _ = require('underscore');
var ShapewaysModel = require('./ShapewaysModel');

var productViewActionCreators = require('js/lib/actions/ProductViewPage/actionCreators');
var productViewActionTypes = require('js/lib/actions/ProductViewPage/actionTypes');

var FALLBACK_MATERIAL = 'SingleColor';

var Product = ShapewaysModel.extend({

  idAttribute: 'spin',
  pluralName:  'products',

  defaults: {
    spin:                     -1,
    currentConfigurationId:   0,
    productTitle:             '',
    shopperTitle:             '',
    shopperDescription:       '',
    shopperPrice:             '',
    fastModelIds:             [],
    fastModels:               {},
    ownerId:                  0,
    ownerName:                '',
    version:                  -1,
    isForSale:                null,
    isPublic:                 null,
    isFirstToTry:             null,
    isProduct:                null,
    categories:               [],
    tags:                     [],
    materials:                [],
    customMakerFragmentUrls:  {},
    isRealMaterialRenderAvailable: false,
    isRealMaterialRenderLoading: false
  },

  initialize: function() {
    var pconfId = parseInt(this.attributes.defaultProductConfigurationId, 10);
    this.set({
      currentConfigurationId: pconfId,
      previewConfigurationId: pconfId
    });
    this.listenTo(this, 'change:currentConfigurationId', this.dispatchConfigurationChangeActions, this);
    this.listenTo(sw, sw.SW_ACTION_EVENT, function(action) {
      var payload = action.payload;

      if (action.type === productViewActionTypes.SHAPE_JS_VIEWER_IS_AVAILABLE) {
        this.setRealMaterialRender(payload.isAvailable);
      } else if (action.type === productViewActionTypes.SHAPE_JS_VIEWER_IS_LOADING) {
        this.setRealMaterialRenderLoading(payload.isLoading);
      }
    }, this);
  },

  dispatchConfigurationChangeActions: function(ProductModel, pconfId) {
    var spin = this.get('spin');
    var currentModelId = null;
    var fragmentUrls = null;

    var currentModel = this.getCurrentModel();

    if (this.isCurrentModelCustomizable()) {

      currentModelId = parseInt(currentModel.id, 10);
      fragmentUrls = this.attributes.customMakerFragmentUrls[currentModelId];

    } else if (currentModel) {
      currentModelId = parseInt(currentModel.id, 10);
    }

    // dispatch actions for selecting the configuration and for updating c-maker
    sw.dispatch(productViewActionCreators.productConfigurationSelected(spin, pconfId, this.isFullColorMaterial(), this.getCurrentModel()));
    sw.dispatch(productViewActionCreators.customMakerModelSelected(spin, pconfId, currentModelId, fragmentUrls));
  },

  /**
   * Determines if the current model is a customizable model.
   * @return {*|int|boolean}
   */
  isCurrentModelCustomizable: function isCurrentModelCustomizable() {
    var currentModel = this.getCurrentModel();
    return currentModel && currentModel.hasCocreator && (currentModel.cocreatorType === 'customizableModel');
  },

  /**
   * Finds if material is full color. If not material
   * is set, return false (the default).
   */
  isFullColorMaterial: function isFullColorMaterial() {
    var pconfId = this.get('currentConfigurationId');
    var materialId = parseInt(this.getMaterialIdForProductConfiguration(pconfId), 10);
    var material = this.getMaterialById(materialId);
    return material && material.isFullColorMaterial;
  },

  /**
   * Determines if any other productDimensionInstances was changed
   * that is not the productDimensionInstance supplied.
   *
   * @param productDimensionInstanceId
   * @returns {boolean}
   */
  isOtherProductDimensionInstanceChange: function(productDimensionInstanceId) {
    var previousPConf = this._previousAttributes.currentConfigurationId,
        previousChoice = this.attributes.mappedProductConfigurationIndex[previousPConf],
        pConf = this.attributes.currentConfigurationId,
        choice = this.attributes.mappedProductConfigurationIndex[pConf],
        productDimensionInstanceIds = Object.keys(this.attributes.productDimensionInstances);
    // if there is only one product dimension then there cannot be a change on dimension
    if (productDimensionInstanceIds.length <= 1) {
      return false;
    }

    var otherProductDimensionInstances = _.filter(productDimensionInstanceIds, function(currentProductDimensionInstanceId) {
        return parseInt(currentProductDimensionInstanceId, 10) !== parseInt(productDimensionInstanceId, 10);
      });
    var result = _.find(otherProductDimensionInstances, function(ProductDimensionInstance) {
        return parseInt(previousChoice[ProductDimensionInstance], 10) !== parseInt(choice[ProductDimensionInstance], 10);
      });
    // if there is at least one other Product Dimension that has changed, return true
    return !_.isUndefined(result);
  },

  /**
   * Finds if material is real material renderable. If no material is set, return false (default).
   *
   * @returns {boolean}
   */
  isRealMaterialRenderCanShow: function() {
    var pconfId = this.get('currentConfigurationId');
    var materialId = parseInt(this.getMaterialIdForProductConfiguration(pconfId), 10);
    var material = this.getMaterialById(materialId);
    var isRealMaterialRenderAvailable = this.get('isRealMaterialRenderAvailable');
    return isRealMaterialRenderAvailable && material;
  },

  /**
   * Return current material's abbreviation
   *
   * @returns {string}
   */
  getMaterialAbbreviation: function() {
    var pconfId = this.get('currentConfigurationId');
    var materialId = parseInt(this.getMaterialIdForProductConfiguration(pconfId), 10);
    var material = this.getMaterialById(materialId);
    if (material && material.isRealMaterialRenderable) {
      return material.materialAbbreviation;
    }
    return FALLBACK_MATERIAL;
  },

  getChoiceByInstanceIdAndChoiceId: function(productDimensionInstanceId, productDimensionChoiceId) {
    return this.attributes.productDimensionInstances[productDimensionInstanceId].productDimension.productDimensionChoices[productDimensionChoiceId];
  },

  getChoiceByInstanceIdAndMaterialId: function(productDimensionInstanceId, materialId) {
    var instances = this.attributes.productDimensionInstances;

    if (!instances[productDimensionInstanceId]) {
      return;
    }

    var choices = instances[productDimensionInstanceId].productDimension.productDimensionChoices;
    var choice = _.find(choices, function(c) {
      if (parseInt(c.valInt, 10) === parseInt(materialId, 10)) {
        return true;
      }
      return false;
    }, this);

    return choice;
  },

  getCurrentChoice: function(dimensionInstanceId) {
    var configId = this.getCurrentProductConfiguration().productConfigurationId;
    var mappedChoices = this.attributes.mappedProductConfigurationIndex[configId];
    var choiceId = mappedChoices[dimensionInstanceId];

    return this.attributes.productDimensionInstances[dimensionInstanceId].productDimension.productDimensionChoices[choiceId];
  },

  getProductDimensionFromDimensionInstanceId: function(dimensionInstanceId) {
    if (!this.attributes.productDimensionInstances[dimensionInstanceId]) {
      return null;
    }
    return this.attributes.productDimensionInstances[dimensionInstanceId].productDimension;
  },

  getProductConfiguration: function(configurationId) {
    configurationId = configurationId || this.attributes.currentConfigurationId;
    return this.attributes.productConfigurations[configurationId];
  },

  getCurrentProductConfiguration: function() {
    return this.getProductConfiguration(this.attributes.currentConfigurationId);
  },

  getCurrentConfiguredProductItems: function() {
    return this.getConfiguredProductItems(this.getProductConfiguration().productConfigurationId);
  },

  getCurrentConfigurationWithPicture: function(productConfigurationId, configuredAttributes) {
    var productConfigurationIdInt = parseInt(productConfigurationId, 0);
    var productItemPics = this.getProductItemPictures(this.attributes.productItems);
    var configurationWithPicture = null;
    _.each(productItemPics[configuredAttributes.itemId], function(pictureObject) {
      if (pictureObject.pictureProductConfigurationId === productConfigurationIdInt) {
        configuredAttributes.productItems[configuredAttributes.itemId].pictureUrl         = pictureObject.pictureUrl;
        configuredAttributes.productItems[configuredAttributes.itemId].pictureDescription = pictureObject.pictureDescription;
        configuredAttributes.productItems[configuredAttributes.itemId].pictureWidth       = pictureObject.pictureWidth;
        configuredAttributes.productItems[configuredAttributes.itemId].pictureHeight      = pictureObject.pictureHeight;
        configurationWithPicture = configuredAttributes.productItems[configuredAttributes.itemId];
      }
    });

    return configurationWithPicture;
  },

  getConfiguredProductItems: function(productConfigurationId) {
    var productItems = this.get('productItems');
    var materials = this.get('materials');

    var items = _.reduce(productItems, function(items, item, itemId) {

      var configuredItem = _.extend({
        quantity: 1,
        itemId: itemId,
        successRateOriginal: '',
        firstToTry: (item.firstToTry < item.yieldCap),
        hasDimensionInstances: !!item.physicalDimensions
      }, item);

      _.each(item.productItemAttributesByProductConfigurationId[productConfigurationId], function(attribute) {

        var val = attribute.valInt || attribute.valChar;
        configuredItem[attribute.productItemAttributeTypeName] = val;
        if (attribute.productItemAttributeTypeName === 'material') {
          configuredItem.materialShopperTitle = materials[val].materialShopperTitle;
          configuredItem.materialDescription = materials[val].materialDescription;
        }

        if (attribute.productItemAttributeTypeName === 'quantity') {
          configuredItem.quantity = parseInt(val, 10);
        }
      });

      if(configuredItem.quantity > 0) {
        items[itemId] = configuredItem;
      }

      return items;
    }, {});

    return items;
  },

  /**
   * Return the information needed to preview a picture.
   *
   * @param productDimensionInstanceId
   * @param choiceId
   * @returns {*}
   */
  getPicturePreviewDataForInstanceIdAndChoice: function(productDimensionInstanceId, choiceId) {
    var pConfId = this.getProductConfigurationIdForInstanceIdAndChoiceId(productDimensionInstanceId, choiceId);
    // Return null if asking to preview the current pConf
    if (pConfId === this.getCurrentProductConfiguration().productConfigurationId) {
      return null;
    }
    var pConfPicture = this.getPictureWithConfigurationId(pConfId);
    var pConfPictureCaption =  '';
    if (!_.isUndefined(pConfPicture)) {
      pConfPictureCaption = pConfPicture.pictureDescription || '';
    }
    if (_.isEmpty(pConfPictureCaption)) {
      var pConf = this.getProductConfiguration(pConfId);
      if (!_.isUndefined(pConf)) {
        pConfPictureCaption = pConf.displayName || '';
      }
    }
    if (!_.isNull(pConfPicture.pictureUrl)) {
      return {
        'pConfPictureUrl': pConfPicture.pictureUrl,
        'pConfPictureCaption': pConfPictureCaption,
        'isShapewaysMaterialRender': pConfPicture.isShapewaysMaterialRender
      };
    }
    return null;
  },

  /**
   * Returns the pConfId for the current product configuration for a different
   * choice id. Meaning if all else stays the same except for the current pConf
   * for the supplied dimension and choice.
   *
   * Example: Missile Dice is selected for side d00 and White Strong & Flexible. Pass the
   * dimensionInstanceId for material and Choice Id for Blue String and Flexible. The returned
   * pConfId will be D00 and Blue Strong & Flexible.
   *
   * @param dimensionInstanceId
   * @param choiceId
   */
  getProductConfigurationIdForInstanceIdAndChoiceId: function(dimensionInstanceId, choiceId) {
    var currentPConfId = this.attributes.currentConfigurationId,
      currentDimensionWithChoices = _.clone(this.attributes.mappedProductConfigurationIndex[currentPConfId]);
    // choiceId must be a string to match mappedProductConfigurationIndex
    currentDimensionWithChoices[dimensionInstanceId] = choiceId.toString();

    var pConfId = _.findKey(this.attributes.mappedProductConfigurationIndex, function(DimensionWithChoices) {
      return _.isEqual(DimensionWithChoices, currentDimensionWithChoices);
    });

    return pConfId;
  },

  getPictureWithConfigurationId: function(productConfigurationId) {

    var pics = _.filter(this.attributes.pictures, function(picture) {
      return parseInt(productConfigurationId, 10) === parseInt(picture.pictureProductConfigurationId, 10);
    });

    if (_.isEmpty(pics)) {
      return null;
    }

    pics = _.sortBy(pics, function(picture) {
      return parseInt(picture.priority, 10);
    });

    return _.first(pics);
  },

  getProductItemPictures: function() {
    var productItems = this.attributes.productItems;
    var productItemIds = _.keys(productItems);
    var pictures = {};

    _.each(productItemIds, function(productItemId) {
      var currentItem = productItems[productItemId];
      pictures[productItemId] = currentItem.productItemPictures;
    });

    return pictures;
  },

  pictureBelongsToConfiguration: function(pictureId, productConfigurationId) {
    var pic = _.find(this.attributes.pictures, function(picture) {
      return parseInt(picture.pictureId, 10) === parseInt(pictureId, 10);
    });

    if (pic && (parseInt(pic.pictureProductConfigurationId, 10) === parseInt(productConfigurationId, 10))) {
      return true;
    }

    return false;
  },

  /**
   * Set if real material render is available or not
   *
   * @param isRealMaterialRenderAvailable
   */
  setRealMaterialRender: function setRealMaterialRender(isRealMaterialRenderAvailable) {
    this.set({
      isRealMaterialRenderAvailable: isRealMaterialRenderAvailable
    });
  },

  /**
   * Set if real material render is spinning or not
   *
   * @param isRealMaterialRenderLoading
   */
  setRealMaterialRenderLoading: function setRealMaterialRenderLoading(isRealMaterialRenderLoading) {
    this.set({
      isRealMaterialRenderLoading: isRealMaterialRenderLoading
    });
  },

  /**
   * Set the current configuration on this model directly
   *
   * This can eventually become an action handler.
   *
   * @param int pconfdId
   */
  setCurrentConfiguration: function setCurrentConfiguration(pconfId) {
    if (!isNaN(parseInt(pconfId, 10))) {
      this.set({currentConfigurationId: parseInt(pconfId, 10)});
    }
  },

  getMaterialIdForProductConfiguration: function(productConfigId) {
    if(this.attributes.productConfigurations && this.attributes.productConfigurations[productConfigId]) {
      return this.attributes.productConfigurations[productConfigId].materialId;
    }
  },

  getDefaultProductConfigurationId: function() {
    return this.attributes.defaultProductConfigurationId;
  },

  getMaterialById: function(materialId) {
    return _.find(this.get('materials'), function(material) {
      return parseInt(material.materialId, 10) === parseInt(materialId, 10);
    });
  },

  /**
   *
   * Returns an array of product config objects that share the selected
   * choice id and dimension instance id.
   *
   * @param dimensionInstanceId
   * @param choiceId
   * @returns {Array}
   */
  getConfigurationsWithChoice: function(dimensionInstanceId, choiceId) {
    var configs = [];

    _.each(this.attributes.mappedProductConfigurationIndex, function(choiceMap, pconfId) {
      if (parseInt(choiceMap[dimensionInstanceId], 10) === parseInt(choiceId, 10)) {
        configs.push(pconfId);
      }
    }, this);

    return configs;
  },

  /**
   *
   * Returns an array of product configuration objects that are related in that
   * all the choices for every product dimension instance are exactly the same
   * _except_ for the choices corresponding to the stipulated
   * dimensionInstanceId.
   *
   * @param dimensionInstanceId
   * @returns {{}}
   */
  getCurrentChoicesForOtherDimensionInstances: function(dimensionInstanceId) {
    var currentConfig = this.getCurrentProductConfiguration();
    var otherChoices = {};

    // Compile a list of all the possible choices from the other dimension instances
    _.each(this.attributes.mappedProductConfigurationIndex[currentConfig.productConfigurationId], function(choiceId, currentDimensionInstanceId) {
      if (parseInt(dimensionInstanceId, 10) === parseInt(currentDimensionInstanceId, 10)) {
        return;
      }

      otherChoices[parseInt(currentDimensionInstanceId, 10)] = parseInt(choiceId, 10);

    }, this);

    return otherChoices;
  },

  /**
   *
   * Gets the available choices for a dimensionInstance for the condition that
   * no other dimension choices are allowed to change.
   *
   * @param dimensionInstanceId
   * @returns {Array}
   */
  getChoicesForDimensionInstance: function(dimensionInstanceId) {
    var otherChoices = this.getCurrentChoicesForOtherDimensionInstances(dimensionInstanceId);

    var choiceIds = [];
    var choiceExists;
    _.each(this.attributes.mappedProductConfigurationIndex, function(mappedChoices) {

      choiceExists = _.every(otherChoices, function(choiceId, did) {
        return parseInt(mappedChoices[did], 10) === parseInt(choiceId, 10);
      }, this);

      if (choiceExists) {
        choiceIds.push(mappedChoices[dimensionInstanceId]);
      }

    }, this);



    return choiceIds;
  },

  /**
   *
   * Updates the currently selected productConfiguration for the dimensionInstanceId to the choiceId
   * that is provided
   *
   * @param dimensionInstanceId
   * @param dimensionChoiceId
   */
  updateChoice: function(dimensionInstanceId, dimensionChoiceId) {
    var otherChoices = this.getCurrentChoicesForOtherDimensionInstances(dimensionInstanceId);

    var configIds = this.getConfigurationsWithChoice(dimensionInstanceId, dimensionChoiceId);

    var matchingConfig = null;
    _.some(configIds, function(configId) {
      var configMapping = this.attributes.mappedProductConfigurationIndex[configId];

      var matchingChoice = _.find(otherChoices, function(choiceId, did) {
        return configMapping[did] && (parseInt(configMapping[did], 10) === parseInt(choiceId, 10));
      }, this);

      if (matchingChoice) {
        matchingConfig = configId;
      }

      return matchingConfig;

    }, this);

    var newCurrentConfigurationId = parseInt(matchingConfig, 10) || parseInt(configIds[0], 10);
    var materialId = this.getMaterialIdForProductConfiguration(newCurrentConfigurationId);
    var material = this.getMaterialById(materialId);

    var shopperTitle = '';
    var shopperDescription = '';

    if(material) {
      shopperTitle = material.materialShopperTitle;
      shopperDescription = material.materialDescription;
    }

    this.set({
      currentConfigurationId: newCurrentConfigurationId,
      shopperTitle: shopperTitle,
      shopperDescription: shopperDescription,
      shopperPrice: this.getProductConfiguration(newCurrentConfigurationId).totalPriceShort
    });
  },

  /**
   * This does not scale for sets
   *
   * @return {int} modelId
   */
  getCurrentModel: function() {
    var currentItem = _.find(this.getCurrentConfiguredProductItems(), function (item) {
      var pItem = this.attributes.productItems[item.itemId];
      return pItem && pItem.modelId;
    }, this);

    if (currentItem) {
      var modelId = this.attributes.productItems[currentItem.itemId].modelId;
      return this.attributes.fastModels[modelId];
    }

    return null;
  }

});

module.exports = Product;
